import React, { FC } from 'react'
import { Link } from 'react-router-dom'
import { FormStateType } from '../../../types'
import {
  Form, Grid, Button, StripeInput, LabelWrapper, Checkbox
} from '../../System'
import ROUTES from '../../utils/routes'
import { OrderSummary } from '../../Auth/OrderSummary'

type Props = {
  form: FormStateType;
  nextStep: () => void;
  changePlan: () => void;
}

const PaymentStep: FC<Props> = ({ form, nextStep, changePlan }) => {
  const { values, setValue } = form

  const canContinue = () => {
    if (values.agreeTerms !== 'yes') {
      return false
    }

    if (!values.card) {
      return false
    }

    if (values.card.error || !values.card.complete) {
      return false
    }

    return true
  }

  return (
    <Form>
      <Grid inLayout gap={12}>
        <div className="order-summary-heading">
          <span>Order Summary</span>
          <span className="change-plan" onClick={changePlan}>
            Change Plan
          </span>
        </div>
        <OrderSummary
          items={[
            {
              ...values.subscription,
              label: values.subscription.name,
              subLabel: values.subscription.sizzle
            }
          ]}
          discountAmount={
            values.subscription.price - (values.subscription.salePrice || values.subscription.price)
          }
        />

        <LabelWrapper
          label="Card Information"
          errorMessage={values.card && values.card.error && values.card.error.message}
        >
          <StripeInput onChange={(card) => setValue('card', card)} />
        </LabelWrapper>

        <Checkbox
          onChange={(checked) => setValue('agreeTerms', checked.target.checked ? 'yes' : 'no')}
          name="agreeTerms"
          label={(
            <>
              I agree to the{' '}
              <a
                href={ROUTES.external.termsOfServiceUrl}
                target="_blank"
                referrerPolicy="no-referrer"
                rel="noreferrer"
              >
                terms of service
              </a>{' '}
              and{' '}
              <a
                href={ROUTES.external.cancellationPolicyUrl}
                target="_blank"
                referrerPolicy="no-referrer"
                rel="noreferrer"
              >
                cancellation policy
              </a>
              .
            </>
          )}
        />
      </Grid>
      <Button
        isDisabled={!canContinue()}
        type="large"
        className="continue-btn"
        onClick={() => nextStep()}
      >
        CONFIRM PAYMENT
      </Button>
      <span className="auth-prompt">
        Already have an account? <Link to={ROUTES.user.login}>Sign In</Link>
      </span>
    </Form>
  )
}

export default PaymentStep
